import { BLOCK_REGISTRY } from "../blockRegistry";

const FOOTER_DEFAULT_BLOCKS = [
  { id: "default-footer-content", type: "footer-content" },
].map((block) => ({
  ...block,
  fields: BLOCK_REGISTRY[block.type].defaultFields,
}));

export default FOOTER_DEFAULT_BLOCKS;
